import React from 'react';
import { SlidersHorizontal, X, RotateCcw } from 'lucide-react';
import SearchFiltersPanel from './SearchFiltersPanel';

/**
 * SearchFiltersMobileDrawer — Drawer mobile plein écran (Phase 3.4)
 */
export default function SearchFiltersMobileDrawer({ open, onClose, filters, setFilter, clearFilter, clearAllFilters, total, loading }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden" data-testid="mobile-filters-drawer">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      {/* Drawer */}
      <div className="absolute inset-y-0 right-0 w-full max-w-sm bg-white shadow-xl flex flex-col animate-in slide-in-from-right">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <SlidersHorizontal className="h-4 w-4 text-gray-600" />
            <span className="text-sm font-bold text-gray-900">Filtres</span>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded" data-testid="close-mobile-filters">
            <X className="h-5 w-5 text-gray-500" />
          </button>
        </div>

        {/* Filters - scrollable */}
        <div className="flex-1 overflow-y-auto px-4 py-3">
          <SearchFiltersPanel
            filters={filters}
            setFilter={setFilter}
            clearFilter={clearFilter}
            clearAllFilters={clearAllFilters}
          />
        </div>

        {/* Footer with result count */}
        <div className="px-4 py-3 border-t border-gray-100 bg-gray-50">
          <button
            onClick={onClose}
            className="w-full py-2.5 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors"
            data-testid="apply-mobile-filters"
          >
            {loading && total === 0 ? 'Chargement...' : `Voir ${total} résultat${total !== 1 ? 's' : ''}`}
          </button>
        </div>
      </div>
    </div>
  );
}
